import "../../App.css";
import NewLandingContent from "../../components/NewLandingContent/NewLandingContent";
import Layout from "../../Layout.js";

function LandingPage() {
  return (
    <Layout>
      <NewLandingContent />
    </Layout>
  );
}

export default LandingPage;
